import AlphabeticalListPage from './AlphabeticalListPage';

globalThis.AlphabeticalList = {
  AlphabeticalListPage,
};
